import React, { useState } from 'react';
import { motion } from 'framer-motion';

const StepperFormModal = ({ isOpen, onClose }) => {
  const [step, setStep] = useState(1); // Step 1: Company, Step 2: Branch

  const nextStep = () => {
    if (step < 2) setStep(step + 1);
  };

  const prevStep = () => {
    if (step > 1) setStep(step - 1);
  };

  return (
    isOpen && (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
        <motion.div
          className="bg-white w-[60%] rounded-xl shadow-lg p-6"
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.9, opacity: 0 }}
          transition={{ duration: 0.3 }}
        >
          <div className="mb-4">
            <h2 className="text-2xl font-semibold text-[#4b3d91] text-center mb-4">Create Organisation</h2>
            <div>
              {/* {step === 1 && <CompanyForm />}  
              {step === 2 && <BranchForm />}   */}
            </div>
          </div>
          <div className="flex justify-between">
            <button
              onClick={prevStep}
              className="px-4 py-2 bg-[#9481ce] text-white rounded-md hover:bg-[#7d6ec0]"
              disabled={step === 1}
            >
              Previous
            </button>
            <button
              onClick={nextStep}
              className="px-4 py-2 bg-[#9481ce] text-white rounded-md hover:bg-[#7d6ec0]"
              disabled={step === 2}
            >
              Next
            </button>
          </div>
         
        </motion.div>
      </div>
    )
  );
};

export default StepperFormModal;
